export const environment = {
    apiUrl: process.env.REACT_APP_API_URL,
    domain: process.env.REACT_APP_DOMAIN,
    passCript: process.env.REACT_APP_PASS_CRIPT,
    passCriptEmail: process.env.REACT_APP_PASS_CRIPT_EMAIL
}